import styled from '@emotion/styled';

export const AppWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100vh',
  minWidth: '300px',
  minHeight: '300px',
  '@media(max-width: 768px)': {
    flexDirection: 'column',
    height: 'calc(max(700px, 100vh)',
  },
}));
